import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Cliente } from 'src/app/models/cliente';
import { Ibge } from 'src/app/models/ibge';
import { ViaCep } from 'src/app/models/viacep';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { IbgeService } from 'src/app/services/ibge.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';
import { GlobalService } from 'src/app/services/global.service';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import swal from 'sweetalert2';
import { FontesConsultaCnpjModel } from "../../dominio/fontes-consulta-cnpj-model";
import { ConsultaCnpjService } from "../../core/services/consulta-cnpj.service";

// jquery
declare const $: any;

@Component({
  selector: "app-venda-direta-modal",
  templateUrl: "./venda-direta-modal.component.html",
  styleUrls: ["./venda-direta-modal.component.scss"],
})
export class VendaDiretaModalComponent implements OnInit {
  clienteFaturamento: Cliente;
  tiposDePessoa = [
    { id: 1, nome: "FÍSICA" },
    { id: 0, nome: "JURÍDICA" },
  ];
  estados = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];
  estadoSelecionado = undefined;
  cidades: Ibge[] = [];
  cidadeSelcionado = undefined;
  veioDaTelaResumoModal = false;

  inscricaoEstadualObg = false;

  venDiNaoAltEndPJ = false;

  validarIeTel = false;

  usuarioLogado: UsuarioLogado;

  premissasSistema = new PremissasSistema();

  customPatterns = {
    V: { pattern: new RegExp("(,|[0-9]|-|\\.)") },
    0: { pattern: new RegExp("[0-9]") },
  };

  fontesConsultaCnpj: FontesConsultaCnpjModel[] = [];

  validaForm: boolean = false;

  public MASKS = MASKS;
  public config: PerfectScrollbarConfigInterface = {};
  constructor(
    public dialogRef: MatDialogRef<VendaDiretaModalComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private ibgeService: IbgeService,
    private utilitarioService: UtilitarioService,
    private viaCepService: ViaCepService,
    private clienteService: ClienteService,
    private premissasService: PremissasService,
    private globalService: GlobalService,
    private consultaCnpjService: ConsultaCnpjService
  ) {
    this.clienteFaturamento = data.clienteFaturamento;
    this.veioDaTelaResumoModal = data.veioDaTelaResumoModal;
    this.validarIeTel = data.validarIeTel;
  }

  async ngOnInit() {
    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.buscarPremissasSistema();
    this.buscarInscricaoEstadualObg();
    this.buscarVenDiNaoAltEndPJ();
    this.buscarFontesConsultaCnpj();

    if (this.clienteFaturamento.uf !== null && this.clienteFaturamento.uf !== undefined) {
      this.estadoSelecionado = this.clienteFaturamento.uf;
    } else {
      this.clienteFaturamento.tipo = 0;
    }
    if (this.clienteFaturamento.ibge !== null && this.clienteFaturamento.ibge !== undefined) {
      this.cidadeSelcionado = this.clienteFaturamento.ibge;
    }

    this.buscarCidades();
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra("buscarPremissasSistema");

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde("buscarPremissasSistema");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissasSistema");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarInscricaoEstadualObg() {
    this.carregandoService.mostra("buscarInscricaoEstadualObg");
    this.premissasService.consultarInscricaoEstadualObg().subscribe(
      (dados) => {
        this.inscricaoEstadualObg = dados.valor;
        this.carregandoService.esconde("buscarInscricaoEstadualObg");
      },
      (erro) => {
        this.carregandoService.esconde("buscarInscricaoEstadualObg");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarVenDiNaoAltEndPJ() {
    this.carregandoService.mostra("buscarVenDiNaoAltEndPJ");
    this.premissasService.consultarVenDiNaoAltEndPJ().subscribe(
      (dados) => {
        this.venDiNaoAltEndPJ = dados.valor;

        if (
          this.veioDaTelaResumoModal &&
          this.usuarioLogado.podeEditarVendaDireta
        ) {
          this.venDiNaoAltEndPJ = false;
        }

        this.carregandoService.esconde("buscarVenDiNaoAltEndPJ");
      },
      (erro) => {
        this.carregandoService.esconde("buscarVenDiNaoAltEndPJ");
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarCliente(idFonte: string = null) {
    await this.buscarClienteBanco();

    if (this.clienteFaturamento.tipo === 1) {
      // CPF só tem consulta no banco, por enquanto
      return;
    }

    const fonte = this.fontesConsultaCnpj.find((x) => x.id == idFonte);

    if (this.clienteFaturamento.ibge === null) {
      // Não retornou cliente, então buscamos na receita
      this.consultarCnpj(idFonte);
    } else {
      swal({
        title: "Atenção!!",
        text: `Deseja atualizar os dados do cliente com no(a) ${fonte.nome}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-info",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.consultarCnpj(idFonte);
        }
      });
    }
  }

  async buscarClienteBanco() {
    if (this.veioDaTelaResumoModal) {
      return;
    }

    const tipoDocumento = this.clienteFaturamento.tipo;
    const documento =
      tipoDocumento === 0
        ? this.clienteFaturamento.cnpj
        : this.clienteFaturamento.cpf;

    if (documento === null) {
      return;
    }

    this.carregandoService.mostra("buscarClienteBanco");

    await this.clienteService
      .consultarPorDoc(documento, tipoDocumento)
      .toPromise()
      .then((cli) => {
        this.clienteFaturamento = cli;

        if (
          this.clienteFaturamento.uf !== null &&
          this.clienteFaturamento.uf !== undefined
        ) {
          this.estadoSelecionado = this.estados.find(
            (s) => s === this.clienteFaturamento.uf
          );
          this.buscarCidades();
        }

        this.carregandoService.esconde("buscarClienteBanco");
      })
      .catch((erro) => {
        this.carregandoService.esconde("buscarClienteBanco");
        this.notificacaoService.erro(erro);
      });
  }

  buscarEnderecoPorCep() {
    this.carregandoService.mostra("buscaEnderecoPorCep");
    this.viaCepService.obterEndereco(this.clienteFaturamento.cep).subscribe(
      (viaCep: ViaCep) => {
        this.clienteFaturamento.bairro = viaCep.bairro;
        // this.cliente.compl = viaCep.complemento;
        this.clienteFaturamento.rua = viaCep.logradouro;
        this.estadoSelecionado = viaCep.uf;
        this.clienteFaturamento.ibge = viaCep.ibge;

        this.buscarCidades();

        this.focalizaNumero();
        this.carregandoService.esconde("buscaEnderecoPorCep");
      },
      (erro) => {
        this.cidadeSelcionado = null;
        this.estadoSelecionado = null;
        this.clienteFaturamento.bairro = null;
        this.clienteFaturamento.rua = null;
        this.validaSalvar();
        this.carregandoService.esconde("buscaEnderecoPorCep");
        this.notificacaoService.erro(
          "Não foi possível acessar o serviço de CEP!"
        );
      }
    );
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra("buscaCidades");
    this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe(
      (ibges: Ibge[]) => {
        this.cidades = ibges;

        if (nomeCidade) {
          this.cidadeSelcionado = this.cidades.find(
            (s) =>
              this.utilitarioService.remover_acentos_espaco(
                s.cidade.toLowerCase().trim()
              ) ===
              this.utilitarioService.remover_acentos_espaco(
                nomeCidade.toLowerCase().trim()
              )
          )
            ? this.cidades.find(
                (s) =>
                  this.utilitarioService.remover_acentos_espaco(
                    s.cidade.toLowerCase().trim()
                  ) ===
                  this.utilitarioService.remover_acentos_espaco(
                    nomeCidade.toLowerCase().trim()
                  )
              ).cod
            : undefined;
        } else {
          this.cidadeSelcionado = this.cidades.find(
            (s) => s.cod === this.clienteFaturamento.ibge
          )
            ? this.cidades.find((s) => s.cod === this.clienteFaturamento.ibge)
                .cod
            : "";
        }

        this.validaSalvar();

        this.carregandoService.esconde("buscaCidades");
      },
      (erro) => {
        this.carregandoService.esconde("buscaCidades");
      }
    );
  }

  focalizaNumero() {
    $("#numero").focus();
  }

  consultarCnpj(idFonte: string | null = null) {
    this.carregandoService.mostra("consultarCnpj");

    this.consultaCnpjService
      .consultar(this.clienteFaturamento.cnpj, idFonte)
      .subscribe(
        (data) => {
          const resultado = data.result;
          const dataAbertura = new Date(resultado.dataAbertura);
          const registroEstadual = resultado.registrosEstaduais
            ? resultado.registrosEstaduais.find((r) => r.uf === resultado.uf)
            : null;
          let telefone: string | null = null;

          if (resultado.telefones && resultado.telefones.length > 0) {
            telefone = resultado.telefones[0];
          }

          let email: string | null = null;

          if (resultado.emails && resultado.emails.length > 0) {
            email = resultado.emails[0];
          }

          this.clienteFaturamento.cnpj = resultado.cnpj;
          this.clienteFaturamento.nome = resultado.razaoSocial;
          this.clienteFaturamento.fantasia = resultado.nomeFantasia ? resultado.nomeFantasia : resultado.razaoSocial;
          this.clienteFaturamento.dtAbert = dataAbertura;

          this.clienteFaturamento.rua = resultado.logradouro;
          this.clienteFaturamento.n = resultado.numero != null ? resultado.numero : this.clienteFaturamento.n;
          this.clienteFaturamento.compl = resultado.complemento != null ? resultado.complemento : this.clienteFaturamento.compl;
          this.clienteFaturamento.bairro = resultado.bairro;
          this.clienteFaturamento.ibge = resultado.codIbge;
          this.estadoSelecionado = resultado.uf;
          this.clienteFaturamento.cep = resultado.cep;

          this.buscarCidades(resultado.cidade);

          if (this.premissasSistema.preencherTelefoneEmailConsultaCnpj) {
            this.clienteFaturamento.tel1 = telefone != null ? telefone : this.clienteFaturamento.tel1;
            this.clienteFaturamento.email = email != null ? email : this.clienteFaturamento.email;
          }

          this.clienteFaturamento.listaCnaes = resultado.atividadesEconomicas.map((x) => x.codigo);
          this.clienteFaturamento.optanteSimples = resultado.simples != null ? resultado.simples.optante : null;
          this.clienteFaturamento.dataSituacaoSimples = resultado.simples != null ? resultado.simples.desde : null;
          this.clienteFaturamento.optanteSimei = resultado.simei != null ? resultado.simei.optante : null;
          this.clienteFaturamento.dataSituacaoSimei = resultado.simei != null ? resultado.simei.desde : null;
          this.clienteFaturamento.inscEst = registroEstadual != null ? registroEstadual.ie : this.clienteFaturamento.inscEst;

          this.clienteFaturamento.dataAtualizacaoReceita = resultado.ultimaAtualizacao
              ? new Date(resultado.ultimaAtualizacao)
              : new Date(Date.now());
          this.clienteFaturamento.fonteAtualizacaoReceita = resultado.fonte;

          this.carregandoService.esconde("consultarCnpj");
        },
        (erro) => {
          this.carregandoService.esconde("consultarCnpj");
          this.notificacaoService.erro(erro);
        }
      );
  }

  voltar() {
    this.dialogRef.close();
  }

  salvar() {
    if (this.validaForm) {
      this.notificacaoService.erro("Preencha os campos obrigatórios!");
      return;
    }

    this.clienteFaturamento.uf = this.estadoSelecionado;
    this.clienteFaturamento.ibge = this.cidadeSelcionado;
    this.clienteFaturamento.cidade = this.cidades.find(
      (s) => s.cod === this.clienteFaturamento.ibge
    )
      ? this.cidades.find((s) => s.cod === this.clienteFaturamento.ibge).cidade
      : "";

    if (this.veioDaTelaResumoModal) {
      this.carregandoService.mostra("salvarClienteVendaDireta");
      this.clienteService
        .salvarClienteVendaDireta(this.clienteFaturamento)
        .subscribe(
          () => {
            this.carregandoService.esconde("salvarClienteVendaDireta");
            this.notificacaoService.sucesso(
              "Endereço de cliente de venda direta atualizado com sucesso!!!"
            );
          },
          (err) => {
            this.carregandoService.esconde("salvarClienteVendaDireta");
            this.notificacaoService.erro(err);
          }
        );
    }

    this.dialogRef.close(this.clienteFaturamento);
  }

  verificaCep() {
    if (!this.clienteFaturamento.cep.includes("_")) this.buscarEnderecoPorCep();
  }

  atualizarCep() {
    window.open("https://viacep.com.br/cep/", "_blank");

    // const largura = Number(($('body').width()));

    // const dialogRef = this.dialog.open(AtualizaCepModalComponent, {
    //   width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
    //   data: {},
    //   panelClass: 'modal-card'
    // });

    // dialogRef.afterClosed().subscribe((result: any) => {

    // });
  }

  limparClienteFaturamento(tipo: number) {
    this.clienteFaturamento = new Cliente();
    this.clienteFaturamento.tipo = tipo;
  }

  validaSalvar() {
    this.validaForm =
      this.estadoSelecionado === undefined ||
      this.estadoSelecionado === null ||
      this.cidadeSelcionado === undefined ||
      this.cidadeSelcionado === null;
    console.log("validaForm", this.validaForm);
  }

  buscarFontesConsultaCnpj() {
    this.carregandoService.mostra("buscarFontesConsultaCnpj");

    this.consultaCnpjService.buscarFontes().subscribe(
      (data) => {
        this.fontesConsultaCnpj = data.results;
        this.carregandoService.esconde("buscarFontesConsultaCnpj");
      },
      (erro) => {
        this.carregandoService.esconde("buscarFontesConsultaCnpj");
        this.notificacaoService.erro(erro);
      }
    );
  }
}
